var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _path, _rect15, _rect16, _rect17, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconLegalDocument(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 25,
    viewBox: "0 0 28 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.03711,
    y: 3.6297,
    width: 13.4815,
    height: 0.77778,
    rx: 0.38889,
    fill: "#4B81AC"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1.03711,
    y: 5.44452,
    width: 13.4815,
    height: 0.77778,
    rx: 0.38889,
    fill: "#4B81AC"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 1.03711,
    y: 7.25946,
    width: 13.4815,
    height: 0.77778,
    rx: 0.38889,
    fill: "#4B81AC"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 1.03711,
    y: 10.6298,
    width: 13.4815,
    height: 0.77778,
    rx: 0.38889,
    fill: "#4B81AC"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 1.03711,
    y: 12.4445,
    width: 13.4815,
    height: 0.77778,
    rx: 0.38889,
    fill: "#4B81AC"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    width: 18.6667,
    height: 21.2593,
    rx: 2,
    fill: "#C1C1C1"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 1.55566,
    y: 1.55554,
    width: 18.6667,
    height: 21.2593,
    rx: 2,
    fill: "#F4F4F4"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 3.88867,
    y: 4.66669,
    width: 11.6667,
    height: 1.25,
    rx: 0.625,
    fill: "#C1C1C1"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 3.88867,
    y: 7.77783,
    width: 7.00002,
    height: 1.25,
    rx: 0.625,
    fill: "#C1C1C1"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 11.667,
    y: 7.77783,
    width: 3.11112,
    height: 1.25,
    rx: 0.625,
    fill: "#C1C1C1"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 3.88867,
    y: 10.8889,
    width: 9.33336,
    height: 1.25,
    rx: 0.625,
    fill: "#C1C1C1"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 3.88867,
    y: 14.0001,
    width: 2.33334,
    height: 1.25,
    rx: 0.625,
    fill: "#C1C1C1"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 14.0001,
    width: 3.8889,
    height: 1.25,
    rx: 0.625,
    fill: "#C1C1C1"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 3.88867,
    y: 17.1111,
    width: 7.7778,
    height: 1.25,
    rx: 0.625,
    fill: "#C1C1C1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.429 21.599C25.5881 22.44 24.2049 22.371 23.4518 21.4506L17.7906 14.5312L19.3612 12.9606L26.2805 18.6219C27.201 19.3749 27.27 20.7581 26.429 21.599Z",
    fill: "#2B7B54"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 17.6338,
    y: 17.2015,
    width: 4.44241,
    height: 6.21938,
    rx: 1,
    transform: "rotate(-135 17.6338 17.2015)",
    fill: "#40946A"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 17.0049,
    y: 19.0863,
    width: 6.21938,
    height: 2.66545,
    rx: 1,
    transform: "rotate(-135 17.0049 19.0863)",
    fill: "#195839"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 22.0312,
    y: 14.0602,
    width: 6.21938,
    height: 2.66545,
    rx: 1,
    transform: "rotate(-135 22.0312 14.0602)",
    fill: "#195839"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.444 20.8248C11.8917 20.8248 11.444 21.2725 11.444 21.8248V22.3124C10.6625 22.6288 10.1113 23.3949 10.1113 24.2898C10.1113 24.5842 10.35 24.8228 10.6444 24.8228H18.9073C19.2017 24.8228 19.4404 24.5842 19.4404 24.2898C19.4404 23.3948 18.8891 22.6287 18.1076 22.3124V21.8248C18.1076 21.2725 17.6599 20.8248 17.1076 20.8248H12.444Z",
    fill: "#413D45"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLegalDocument);
export default __webpack_public_path__ + "static/media/icon_legal_document.137093d7e71d315be26ad2df8a6dcfe0.svg";
export { ForwardRef as ReactComponent };